<template>
  <router-view />
</template>

<script>
export default {
  name: "app-location"
};
</script>

<style lang="scss" scoped></style>
